import type { ReactNode } from 'react';

export const symbol_arrow_right: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M415.32-301q-6.32 0-10.82-4.13-4.5-4.12-4.5-10.87v-328q0-6.75 4.64-10.88 4.63-4.12 10.81-4.12 1.55 0 10.55 5l158 158q3 3 5 7.06t2 8.94q0 4.87-2 8.94-2 4.06-5 7.06L426-306q-2 2-4.76 3.5-2.77 1.5-5.92 1.5Z"
		/>
	</svg>
);
